import { createMongoAbility, MongoAbility } from '@casl/ability';

export type AppAbility = MongoAbility<[string, string]>;

export const ability = createMongoAbility<AppAbility>([]);
